var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAlert)?_c('section',{staticClass:"global-alert"},[_c('div',{staticClass:"global-alert__close",on:{"click":_vm.hideAlert}},[_vm._v("×")]),(_vm.alertText)?_c('EditorJSComponent',{attrs:{"text":JSON.parse(_vm.alertText)}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }